import { createBlankCondition } from './createBlankCondition';
import { convertToIsWithinGeoLocationCondition } from './convertToIsWithinGeoLocationCondition';
import { CompleteCondition, EditableCondition } from '../types';

/** converts ComplateCondition to CompleteCondition */
export const convertToEditableCondition = (condition: CompleteCondition): EditableCondition =>
  createBlankCondition(condition.dataType, convertToIsWithinGeoLocationCondition({ ...condition }));
